import { chain } from '@leprecoins/effector';
import { createMaster } from '@leprecoins/effector-sounds';
import { createEvent, createStore } from 'effector';
import { persist } from 'effector-storage/local';
import cashoutSoundSrc from 'shared/ui/assets/sounds/cashout-sound.mp3';
import clickSoundSrc from 'shared/ui/assets/sounds/click-sound.mp3';
import loseSoundSrc from 'shared/ui/assets/sounds/lose-sound.mp3';
import startSoundSrc from 'shared/ui/assets/sounds/start-sound.mp3';
import winSoundSrc from 'shared/ui/assets/sounds/win-sound.mp3';

const setup = createEvent();

const [master, createSound] = createMaster({ setup });

const $controlledVolume = createStore(1);

export const clickSound = createSound({ src: clickSoundSrc });

export const cashoutSound = createSound({ src: cashoutSoundSrc, volumeScale: 0.6 });

export const loseSound = createSound({ src: loseSoundSrc });

export const startSound = createSound({ src: startSoundSrc });

export const winSound = createSound({ src: winSoundSrc });

chain(master.$volume, $controlledVolume);

chain($controlledVolume, master.setVolume);

persist({
	store: $controlledVolume,
	key: 'leprecoins_stepball_sounds',
});

export const soundsMaster = Object.assign(master, { setup });

export { createSound };
